// extracted by mini-css-extract-plugin
export default {"search_input":"searchInput_search_input__2D0Na","input":"searchInput_input__BBH+9","icon":"searchInput_icon__Z6lrG","iconPath":"searchInput_iconPath__LsNAx"};